var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 12.6666H18.0003V18H15.3337V12.6666H10.0003V9.99996H15.3337V4.66663H18.0003V9.99996H23.3337V12.6666ZM24.667 0.666626H8.66699C7.95975 0.666626 7.28147 0.947577 6.78137 1.44767C6.28128 1.94777 6.00033 2.62605 6.00033 3.33329V19.3333C6.00033 20.0405 6.28128 20.7188 6.78137 21.2189C7.28147 21.719 7.95975 22 8.66699 22H24.667C25.3742 22 26.0525 21.719 26.5526 21.2189C27.0527 20.7188 27.3337 20.0405 27.3337 19.3333V3.33329C27.3337 2.62605 27.0527 1.94777 26.5526 1.44767C26.0525 0.947577 25.3742 0.666626 24.667 0.666626ZM3.33366 5.99996H0.666992V24.6666C0.666992 25.3739 0.947944 26.0521 1.44804 26.5522C1.94814 27.0523 2.62641 27.3333 3.33366 27.3333H22.0003V24.6666H3.33366V5.99996Z",
    fill: "#4D5062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddImg);
export default __webpack_public_path__ + "static/media/icon_add_img.bce7846480206b874a24b761375ea927.svg";
export { ForwardRef as ReactComponent };